import store from "../../../../store";
import { toggleAudio } from "./media";
import { getKeyForBrowser } from "../../../../utilities/Helpers";
import { toggleOwnState, toggleOwnSupportState } from "../SessionHelpers/session";

export async function initShortcuts(e) {
  /* handle key event for different browsers */
  let key = getKeyForBrowser(e);

  if (store.state.modals.reportModal) return;

  if (!key) {
    return;
  }
  const className = e.target.className;
  const classList = e.target.classList;
  if (className == "chatInputBox" || classList.contains("chatInputBox")) {
    if (key == 27) {
      // escape input box
      document.getElementById("chatInputBox").blur();
    } else {
      return;
    }
  }

  if (className == "setting-input" || classList.contains("setting-input")) {
    if (key == 27) {
      // escape input box
      document.getElementById("taskInput").blur();
    } else {
      return;
    }
  }

  if (className == "timer-input" || classList.contains("timer-input")) {
    if (key == 13) {
      document.getElementById("start-timer").click();
    } else {
      return;
    }
  }

  if (className == "room-password" || classList.contains("room-password")) {
    if (key == 13) {
      document.getElementById("check-pass").click();
    } else {
      return;
    }
  }
  if (classList.contains("eventroom-name")) {
    return;
  }

  /* MEDIA TOGGLES */
  if (key == 77) {
    await toggleAudio();
  }

  /* LAYOUT TOGGLES */
  if (key == 49) {
    store.dispatch("preferences/toggleLayout", 1);
  } else if (key == 50) {
    store.dispatch("preferences/toggleLayout", 2);
  } else if (key == 51) {
    store.dispatch("preferences/toggleLayout", 3);
  }

  // else if (key == 52) {
  //   store.dispatch("preferences/toggleLayout", 4);
  // }

  /* STATE TOGGLES */
  if (key == 66) {
    /* If key is 'b' for brb */
    toggleOwnState("brb");
  }
  /* Don't check supporting state toggles if brb not enabled */
  if (!store.state.mediastates.ownState.brb.value) {
    return;
  }
  /* SUPPORTING STATE TOGGLES */
  const currentSupport = store.state.mediastates.ownState.brb.supportState;
  let supportState = "";
  if (key == 67) {
    /* If key is 'c' for coffee */
    const support = "coffee";
    if (currentSupport !== support) {
      supportState = support;
    }
  } else if (key == 84) {
    /* If key is 't' for tea */
    const support = "tea";
    if (currentSupport !== support) {
      supportState = support;
    }
  } else if (key == 87) {
    /* If key is 'w' for water */
    const support = "water";
    if (currentSupport !== support) {
      supportState = support;
    }
  } else if (key == 82) {
    /* If key is 'r' for restroom */
    const support = "restroom";
    if (currentSupport !== support) {
      supportState = support;
    }
  } else if (key == 68) {
    /* If key is 'd' for dinosaur */
    const support = "dino";
    if (currentSupport !== support) {
      supportState = support;
    }
  } else if (key == 85) {
    /* If key is 'u' for unicorn */
    const support = "unicorn";
    if (currentSupport !== support) {
      supportState = support;
    }
  } else if (key == 75) {
    /* If key is 'k' for kitty */
    const support = "kitty";
    if (currentSupport !== support) {
      supportState = support;
    }
  }

  toggleOwnSupportState(supportState);
}

export default {
  initShortcuts,
};
